import React from 'react';
import { TouchTarget } from 'apps/sigma2-ui/src/components/ui/TouchTarget';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import cn from 'classnames';
import { TranslatedContent } from 'libs/end-to-end/src/translation-content';

export interface PrimaryButtonLightBgProps {
  /**
   * Callback when the button is clicked
   */
  onClick: () => void;

  /**
   * Whether or not the button is disabled
   */
  disabled: boolean;

  /**
   * The label for the button
   */
  translatedContent?: TranslatedContent;

  /**
   * The class name for the button
   */
  className?: string;

  /**
   * The class name for the inner button
   */
  innerClassName?: string;

  /**
   * The icon for the button to be shown on the left
   */
  icon?: (props: {
    hovered: boolean;
    focused: boolean;
    active: boolean;
  }) => React.ReactNode | null;

  circle?: boolean;
  testId?: string;
}

export const PrimaryButtonLightBg = ({
  translatedContent,
  onClick,
  disabled,
  className,
  innerClassName,
  icon,
  circle = false,
  testId,
}: PrimaryButtonLightBgProps) => {
  return (
    <TouchTarget
      className={cn('inline-block max-w-full', className)}
      disabled={disabled}
      testId={testId}
      behavior={{
        type: 'onClick',
        onClick: () => {
          onClick();
        },
      }}
      content={({ hovered, focused, active }) => {
        return (
          <div
            className={cn(
              `flex w-full text-center items-center  border-box transition-colors whitespace-nowrap select-none gap-2.5`,
              {
                'h-[40px] px-6 rounded': !circle,
                'p-6 rounded-full': circle,
                'cursor-pointer': !disabled,
                'cursor-not-allowed': disabled,
                'bg-royal-800': !disabled && !hovered && !focused && !active,
                'bg-royal-900': !disabled && (hovered || focused),
                'bg-royal-1000': !disabled && active,
                'bg-gray-200': disabled,
              },
              innerClassName,
            )}
          >
            {icon && icon({ hovered, focused, active })}
            {translatedContent && (
              <S2Typography
                as={'span'}
                translatedContent={translatedContent}
                variant={'headline-6-alt'}
                textColorVariant={disabled ? 'gray-400' : 'violet-100'}
                truncate={true}
                flex={true}
              />
            )}
          </div>
        );
      }}
    />
  );
};
